/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFilePdf = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4zm11 3.414V7h1.586z" />
        <path d="M9.651 17v-4.87h1.742c.599 0 1.05.138 1.354.415.308.276.462.687.462 1.232 0 .54-.154.952-.462 1.233-.304.277-.755.415-1.353.415h-.704V17zm1.528-4.02h-.489v1.595h.49c.356 0 .609-.06.756-.181.152-.125.228-.33.228-.617 0-.29-.076-.495-.228-.616-.147-.12-.4-.181-.757-.181zM13.852 17v-4.87h1.635c.795 0 1.396.205 1.802.616.407.41.61 1.018.61 1.822 0 .795-.203 1.4-.61 1.816-.402.41-1.003.616-1.802.616zm1.621-4.02h-.576v3.17h.576c.452 0 .787-.128 1.005-.383.224-.259.335-.659.335-1.2s-.109-.94-.328-1.198c-.219-.26-.556-.389-1.011-.389zM18.642 17v-4.87h3.108v.884h-2.063v1.226h1.829v.884h-1.83V17z" />
      </g>
    </g>
  </Icon>
);
export { SvgFilePdf as FilePdf };
